// extracted by mini-css-extract-plugin
module.exports = {"avatarImg":"form_avatarImg_3IAQb","clearButtonContainer":"form_clearButtonContainer_1wC88"};